// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardColors_container__L8O3N","colorBubbleImage":"ProductCardColors_colorBubbleImage__1rP22","nbHidden":"ProductCardColors_nbHidden__15Ujx"};